import news24 from "../../../images/frontpage/latestnews/news24.jpg";
import news10 from "../../../images/frontpage/latestnews/news10.jpg";
import news21 from "../../../images/frontpage/latestnews/news21.jpg";
import news5 from "../../../images/frontpage/latestnews/news5.jpg";

export const latestnewsdata = [
    [
        {
            news_sid: 1,
            news_img: news24,
            news_title: "🍰天造地設的幸福絕配 來拎+B即將推出5款經典蛋糕🍰",
            news_start_date: "2022-08-24",
            news_end_date: "2022-08-08",
            news_content: `----風味聯姻 天造地設的幸福絕配---<br/>
        🍰 卡士達千層蛋糕領軍 來拎+B推出5款經典蛋糕 🍰<br/>
        以咖啡融入生活的五感，讓生活滋味妝點著咖啡的甘以及蛋糕的甜<br/>
        來拎+以咖啡風味聯姻概念，打造5款與咖啡絕配的經典甜點<br/>
        讓咖啡與甜點迷用來拎+好咖啡與經典甜點，幸福包覆著每日生活<br/>
        即日起到12月19日點購全新的5款「經典甜點」，再加「本日精品」咖啡，可享10元現折優惠`,
        news_content2: `｜　注意事項　｜<br/><br/>
        ＊本活動適用飲品、餐食、糕點，不提供寄杯服務。<br/>
＊實體門市限定，你訂線上訂餐自取同享優惠，不適用外送及其他網路訂餐服務。<br/>
＊優惠不重複，不與其他行銷活動並行，自備環保杯折五元除外。<br/>
＊以 Menu 常態販售商品為準，其他商品不在活動範圍內。<br/>
＊以門市實際販售之商品庫存為準。<br/>
＊不適用點數兌換。<br/>
＊圖片僅供參考，實品以實物為準。<br/><br/><br/>
【防疫期間使用說明】<br/><br/>
1. 防疫期間各店容留人數有限制，請事先電話預約訂位。<br/>
2. 各店營業時間與最後供餐時間請依官網公告為準。<br/>
3. 進入現場之貴賓，敬請依現場相關防疫規定取餐、用餐，並請於未用餐時戴上口罩，感謝您的支持與配合。`
        },
    ],
    [
        {
            news_sid: 2,
            news_img: news10,
            news_title: "☕ 「茶萃咖啡歐蕾」 ☕<br/> 現萃茶香與經典拿鐵的完美結合",
            news_start_date: "2022-08-26",
            news_end_date: "2022-09-30",
            news_content:
                "乍暖還寒，大地透露明媚春光，此時咖啡跟茶的癮頭上了心！在這個美好季節，來拎+B推出全新研發「茶萃咖啡歐蕾」，以榮獲「AICA澳洲咖啡國際大賽」銅牌的哥倫翡玉精品咖啡豆做為基底，新鮮萃取淺火烘焙烏龍茶，搭配香濃牧場鮮乳入口即可品嚐到飽滿的茶香、咖啡的甜感與堅果韻味，最後交融在純厚的乳脂中以茶引味，達到「拿鐵的全新境界」同步推出優化升級的「靜岡抹茶小農鮮乳」、「靜岡抹茶小農拿鐵」延續崙背鮮乳的消費熱潮，搭配日本直輸靜岡抹茶一口嚐盡春回大地的清爽與滋養。",
                news_content2: `｜　注意事項　｜<br/><br/>
                ＊本活動適用飲品、餐食、糕點，不提供寄杯服務。<br/>
        ＊實體門市限定，你訂線上訂餐自取同享優惠，不適用外送及其他網路訂餐服務。<br/>
        ＊優惠不重複，不與其他行銷活動並行，自備環保杯折五元除外。<br/>
        ＊以 Menu 常態販售商品為準，其他商品不在活動範圍內。<br/>
        ＊以門市實際販售之商品庫存為準。<br/>
        ＊不適用點數兌換。<br/>
        ＊圖片僅供參考，實品以實物為準。<br/><br/><br/>
        【防疫期間使用說明】<br/><br/>
        1. 防疫期間各店容留人數有限制，請事先電話預約訂位。<br/>
        2. 各店營業時間與最後供餐時間請依官網公告為準。<br/>
        3. 進入現場之貴賓，敬請依現場相關防疫規定取餐、用餐，並請於未用餐時戴上口罩，感謝您的支持與配合。`
        },
    ],
    [
        {
            news_sid: 3,
            news_img: news21,
            news_title:
                "😋到來拎+B找尋自己的拿鐵真愛😋<br/>「微韻輕拿鐵」、「贅沢厚乳拿鐵」秋日幸福上市",
            news_start_date: "2022-08-28",
            news_end_date: "2022-10-31",
            news_content:
                "來拎+B推出全新「微韻輕拿鐵」與「贅沢厚乳拿鐵」兩款拿鐵新品<br/>讓廣大拿鐵愛好者，不再選擇困難！<br/>無論您對拿鐵的的偏好是淡雅滑順，或是需要有四溢的乳香<br/>在來拎+B都可以找到您的拿鐵真愛。<br/>💯 清爽系「微韻輕拿鐵」：以輕量濃縮咖啡比例，搭配淡麗爽口的鮮奶，淡淡咖啡香氣與甘甜奶味互相映襯，口味清爽、滑順如絲<br/>飲用起來輕盈但香氣悠長。相當適合不喜歡咖啡味太重的消費者。<br/>💯 濃厚系「贅沢厚乳拿鐵」：贅沢為日文豪華、奢侈的意思，用以表現食材的奢華或是口感的豐富。<br/>",
                news_content2: `｜　注意事項　｜<br/><br/>
                ＊本活動適用飲品、餐食、糕點，不提供寄杯服務。<br/>
        ＊實體門市限定，你訂線上訂餐自取同享優惠，不適用外送及其他網路訂餐服務。<br/>
        ＊優惠不重複，不與其他行銷活動並行，自備環保杯折五元除外。<br/>
        ＊以 Menu 常態販售商品為準，其他商品不在活動範圍內。<br/>
        ＊以門市實際販售之商品庫存為準。<br/>
        ＊不適用點數兌換。<br/>
        ＊圖片僅供參考，實品以實物為準。<br/><br/><br/>
        【防疫期間使用說明】<br/><br/>
        1. 防疫期間各店容留人數有限制，請事先電話預約訂位。<br/>
        2. 各店營業時間與最後供餐時間請依官網公告為準。<br/>
        3. 進入現場之貴賓，敬請依現場相關防疫規定取餐、用餐，並請於未用餐時戴上口罩，感謝您的支持與配合。`
        },
    ],
    [
        {
            news_sid: 4,
            news_img: news5,
            news_title:
                "新品上市 /源自日本的濃萃咖啡球<br/>9/12 起來拎+B門市搶先品嚐享限時9折",
            news_start_date: "2022-09-12",
            news_end_date: "2022-09-26",
            news_content:
                "濃萃咖啡球是透過日本「獨特的連續筒狀真空高壓萃取技術」與「香氣回收技術」，利用加壓的方式 將咖啡成分萃取出來並完整保留咖啡豆的原始香氣，整體風 味平衡富含核桃堅果香氣，尾韻帶有麥芽糖甜感及奶油滑順的口感，加入鮮乳飲用更濃郁香甜，在家或戶外也能輕鬆享有一杯好咖啡。\r\n濃萃咖啡球(10顆/盒) 於門市＆官網同步販售中。\r\n5.23 MON - 5.27 FRI 新品上市9折嚐鮮價378元 (原價420元)\r\n",
                news_content2: `｜　注意事項　｜<br/><br/>
                ＊本活動適用飲品、餐食、糕點，不提供寄杯服務。<br/>
        ＊實體門市限定，你訂線上訂餐自取同享優惠，不適用外送及其他網路訂餐服務。<br/>
        ＊優惠不重複，不與其他行銷活動並行，自備環保杯折五元除外。<br/>
        ＊以 Menu 常態販售商品為準，其他商品不在活動範圍內。<br/>
        ＊以門市實際販售之商品庫存為準。<br/>
        ＊不適用點數兌換。<br/>
        ＊圖片僅供參考，實品以實物為準。<br/><br/><br/>
        【防疫期間使用說明】<br/><br/>
        1. 防疫期間各店容留人數有限制，請事先電話預約訂位。<br/>
        2. 各店營業時間與最後供餐時間請依官網公告為準。<br/>
        3. 進入現場之貴賓，敬請依現場相關防疫規定取餐、用餐，並請於未用餐時戴上口罩，感謝您的支持與配合。`
        },
    ],
];
